import { CCMServiceProvider, ProgramExtensionStatusReason } from '../enums';
import { Employee } from './Employee';
import { make } from './Model';
import { ProgramExtension } from './ProgramExtension';
import { ProgramExtensionStatus } from './ProgramExtensionStatus';

export class MemberProgramExtension {
  id = 0;

  programExtension: ProgramExtension;

  status?: ProgramExtensionStatus;

  statusReason?: ProgramExtensionStatusReason;

  statusReasonOther = '';

  createdAt = 0;

  createdBy: Employee;

  updatedAt = 0;

  updatedBy: Employee;

  releaseDate = '';

  serviceProvider?: CCMServiceProvider;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.createdBy = make(obj.createdBy, Employee);
    this.programExtension = make(obj.programExtension, ProgramExtension);
    this.serviceProvider = CCMServiceProvider.byKey[obj.serviceProvider];
    this.status = make(obj.status, ProgramExtensionStatus);
    this.statusReason = obj.statusReason
      ? ProgramExtensionStatusReason.byKey[obj.statusReason]
      : undefined;
    this.updatedBy = make(obj.updatedBy, Employee);
  }

  static sort(
    { programExtension: a }: MemberProgramExtension,
    { programExtension: b }: MemberProgramExtension,
  ) {
    return ProgramExtension.sort(a, b);
  }

  static clone(mpe: MemberProgramExtension) {
    const clone = { ...mpe };
    return Object.setPrototypeOf(clone, MemberProgramExtension.prototype);
  }
}

export default MemberProgramExtension;
